var GiftDeliveryChooserView = (function () {
    return function (model) {
        var addressGiftFormView = new AddressGiftFormView({ model: model });
        var addressBillingView = new AddressGiftView({ model: model });
        var addressBillingButtonView = new AddressBillingButtonView({ model: model });

        var addressBillingFormView = new AddressBillingFormView({ collection: model.billingForm() });
        var addressBillingView = new AddressBillingView({ model: model });
        var addressGiftButtonView = new AddressGiftButtonView({ model: model });
        var addressGiftListView = new AddressGiftListView({ collection: new GiftAddresses([]) });

        //var messageGiftFormView = new GiftMessageFormView({ model: model.currentGiftMessage() });
        var messageGiftView = new GiftMessageView({ model: model });
        var messageGiftButtonView = new GiftMessageButtonView({ model: model });
    };
})();